import Boxform from './Boxform';
import React, { Component, useState, useEffect, useContext } from "react";
import axios from "axios";
import { Cookies } from '../../../index.js';
import { isMobile } from 'react-device-detect';
import { alert_error, alert_success } from "../../../AppContext";
import { MyContext } from '../urlshorten_system/index'; // hoặc './Indexok'
import Mode_ads_lite from '../urlshorten_mode/mode_system/mode_ads_lite';
import Mode_remix_lists from '../urlshorten_mode/mode_system/mode_remix_lists';
import Mode_ads_pro from '../urlshorten_mode/mode_system/mode_ads_pro';
import Mode_tiktok_cmt from '../urlshorten_mode/mode_social/mode_tiktok_cmt';
import Mode_partner from '../urlshorten_mode/mode_partner/mode_partner';
import Mode_tiktok_heart from '../urlshorten_mode/mode_social/mode_tiktok_heart';
import Mode_roll_up from '../urlshorten_mode/mode_system/mode_roll_up';
import Mode_partner_ads from '../urlshorten_mode/mode_partner/mode_partner_ads';
import Mode_google_maps from '../urlshorten_mode/mode_traffix/mode_google_maps';
import Mode_image_check from '../urlshorten_mode/mode_traffix/mode_image_check';
import Mode_videos_check from '../urlshorten_mode/mode_traffix/mode_videos_check';
import Check_done from './check_done.jsx';
import Link_done from './link_done.jsx';
import Buy_link from '../urlshorten_mode/mode_system/mode_buy_link';
import Login_google from './login.jsx';
import { RingLoader, MoonLoader } from "react-spinners";
function Checkstart() {
    const { step_service, setstep_service, caption, setcaption,
        show_link_done, setshow_link_done, money_link, setmoney_link,
        link_done, setlink_done, set_remix_lists } = useContext(MyContext);
    const [step_total, setstep_total] = useState('');
    const [step_actions, setstep_actions] = useState('');
    const [ip_address_v4, set_ip_address_v4] = useState('');
    const [lienketok, setlienketok] = useState('');
    const [service_name, setservice_name] = useState('');
    const [starter, set_starter] = useState(false);
    const [non_login, set_non_login] = useState(false);
    function laydulieu(device_type) {
        const myCookieValue = Cookies.get("apikey");
        const code_item = Cookies.get("code_item");
        const hustmediavipro = Cookies.get("hustmediavipro");

        axios
            .get("https://hust.media/link/load_logic/check_start.php", {
                params: {
                    lienket: hustmediavipro,
                    apikey: myCookieValue,
                    code_item: code_item,
                    device_type: device_type,
                    ip_address_v4: ip_address_v4
                },
            })
            .then((response) => {
                testFunction(response);
            })
            .catch((error) => {
                alert_error(error);
            });
    }
    function testFunction(response) {
        const info = response.data;
        const status = info.status;
        const message = info.message;
        const code_item = info.code_item;
        const step_service = info.step_service;
        const step_total_ok = info.step_total;
        const step_actions_ok = info.step_actions;
        const service_name = info.step_service_name;
        const order = info.order;
        const money_link = info.money_link;
        const newbie_buff = info.newbie_buff;
        const remix_lists = info.remix_lists;
        if (status == 0) {
            alert_error(message);
        }
        else if (status == 8) {
            set_non_login(true);
            alert_error(message);
        }
        else if (status == 1) {
            alert_success(message);
            if (order) {
                setshow_link_done(true);
                setlink_done(order);
            }
        }
        else if (status == 7) {
            setshow_link_done(true);
            setlienketok(response.data.url);
        }
        else if (status == 9) {
            alert_success(message);
        }
        if (code_item) {
            Cookies.set('code_item', code_item, { expires: 1 / 12 });
        }
        if (newbie_buff) {
            Cookies.set('newbie_buff', newbie_buff, { expires: 1 / 12 });
        }
        if (step_total_ok && step_actions_ok) {
            setstep_actions(step_actions_ok);
            setstep_total(step_total_ok);
        }
        if (service_name) {
            setservice_name(service_name);
        }
        if (step_service) {
            setstep_service(step_service);
        }
        if (remix_lists) {
            set_remix_lists(remix_lists);
        }
        if (money_link) {
            setmoney_link(money_link);
        }
        if (info.redirects != null && info.redirects != '') {
            setTimeout(function () {
                // Chuyển hướng sang trang web khác
                window.location.href = info.redirects;
            }, 1700);
        }
    };

    useEffect(() => {
        axios
            .get("https://api.ipify.org/?format=json")
            .then((response) => {
                if (response.data.ip) {
                    set_ip_address_v4(response.data.ip)
                    set_starter(true);
                }
                else {
                    set_starter(true);
                }
            })
            .catch((error) => {
                // alert_error(error);
                set_starter(true);
            });
    }, []);
    useEffect(() => {
        if (starter) {
            if (isMobile) {
                laydulieu('phone');
            }
            else {
                laydulieu('pc');
            }
        }
    }, [starter]);
    function dichden() {
        window.open(link_done, "_blank");
    }
    return (
        <div>
            <Boxform>
                {show_link_done ? (
                    <>
                        <Link_done />
                    </>

                )
                    : non_login ? (<>
                        <div className="mb-1 ">
                            <div>Tiếp tục với google để nhận links miễn phí</div>
                            <Login_google />
                        </div>
                    </>)
                        : !step_service ? (

                            <div className="mt-2 flex justify-center items-center">
                                <MoonLoader size={50} color="#003AA5" />{" "}
                            </div>

                        ) : step_service == 'check_done' ?
                            (<>
                                <Check_done />
                            </>)
                            : (
                                <>
                                    <div className="mb-0 text-sm flex justify-center items-center">Mô tả :</div>
                                    <div className="items-center">
                                        {caption}
                                    </div>
                                    {step_service == 'remix_lists' ? (<>
                                        <Mode_remix_lists />
                                    </>) : (<>
                                        <div className="text-sm items-center mb-1">
                                            Số bước : {step_actions} / {step_total}, Jop : {service_name}
                                        </div>
                                    </>)}
                                    {step_service == 'ads_lite' ?
                                        (<>
                                            <Mode_ads_lite />
                                        </>) : step_service == 'partner_ads' ? (<>
                                            <Mode_partner_ads />
                                        </>)
                                            : step_service.includes('partner') ? (<>
                                                <Mode_partner />
                                            </>) : step_service == 'tiktok_heart' ? (<>
                                                <Mode_tiktok_heart />
                                            </>) : step_service == 'ads_pro' ? (<>
                                                <Mode_ads_pro />
                                            </>) : step_service == 'roll_up' ? (<>
                                                <Mode_roll_up />
                                            </>) : step_service == 'buy_link' ? (<>
                                                <Buy_link />
                                            </>) : step_service == 'reviews_maps' ? (<>
                                                <Mode_google_maps />
                                            </>) : (step_service.includes('image_check') || step_service.includes('ads_max') )
                                                ? (<>
                                                    <Mode_image_check />
                                                </>) : ( step_service.includes('videos_check') || step_service.includes('p2p_mmo') )
                                                    ? (<>
                                                        <Mode_videos_check />
                                                    </>) : step_service.includes('tiktok_cmt')
                                                        ? (<>
                                                            <Mode_tiktok_cmt />
                                                        </>) : (<>
                                                            ko tìm thấy
                                                        </>)}
                                </>
                            )}

            </Boxform>
        </div>
    );
}

export default Checkstart;